<template>
  <div class="uvindex-legenda">
    <strong>Podľa hodnoty UVI si treba zvoliť ochranné prostriedky pred slnečným UV žiarením:</strong>
    <table class="table">
      <tbody>
      <tr>
        <td style="background-color:rgb(204, 204, 204); text-align:center; width:70px"><span style="color:#008000"><strong>UVI 0 - 2</strong><br>
			nízky</span></td>
        <td>pobyt vo vonkajšom prostredí bez ochranných prostriedkov je bezpečný&nbsp;</td>
      </tr>
      <tr>
        <td style="background-color:rgb(204, 204, 204); text-align:center"><span style="color:#FFFF00"><strong>UVI 3 - 5</strong><br>
			stredný</span></td>
        <td>v poludňajších hodinách (10-15 LSEČ)&nbsp;treba vyhľadať tieň, vonku sa treba chrániť odevom, pokrývkou hlavy, ochranným krémom a okuliarmi</td>
      </tr>
      <tr>
        <td style="background-color:rgb(204, 204, 204); text-align:center"><span style="color:#FF8C00"><strong>UVI 6 - 7</strong><br>
			vysoký</span></td>
        <td><span style="background-color:rgb(255, 255, 255)">v poludňajších hodinách (10-15 LSEČ)&nbsp;treba vyhľadať tieň, vonku sa treba chrániť odevom, pokrývkou hlavy, ochranným krémom a okuliarmi</span></td>
      </tr>
      <tr>
        <td style="background-color:rgb(204, 204, 204); text-align:center"><span style="color:#FF0000"><strong>UVI 8<sup>+</sup></strong><br>
			veľmi vysoký</span></td>
        <td>treba sa vyhnúť pobytu vonku v poludňajších hodinách&nbsp;(10-15&nbsp;LSEČ), uistiť sa, či tieň poskytuje dostatočnú ochranu pred slnečným žiarením,&nbsp;&nbsp;ochrana&nbsp;odevom, pokrývkou hlavy, ochranným krémom a okuliarmi je nutnosťou</td>
      </tr>
      </tbody>
    </table>
    <div class="text-align-center">
      <img src="http://www.shmu.sk/Image/uvindex/uvindex_v2.png" class="img-fluid">
    </div>
  </div>
</template>

<script>


export default {
  components: {},
  name: 'UVIndexLegenda',
  props: {}
}

</script>
